/*
 * Gift In One vector template geometry, revision 1.
 * One byte-identical UMD module is shipped to the browser and production renderer.
 * Artwork in this module is original work for Gift In One. No external images,
 * SVG markup, fonts or scripts are accepted by the template geometry compiler.
 *
 * Coordinates: slots/text rectangles are normalized to the complete canvas.
 * Decorations use template.viewBox coordinates. maskPath takes LOCAL SLOT pixel
 * dimensions (not canvas dimensions). Decor is drawn after photos, before text.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.GIOTemplateCore = factory();
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var VERSION = '1';
  var FAMILIES = [
    { id: 'family-moments', label: 'Family Moments', description: 'A clean frame with balanced photo arrangements.' },
    { id: 'botanical-keepsake', label: 'Botanical Keepsake', description: 'Round photographs with original leaf details.' },
    { id: 'love-memories', label: 'Love & Memories', description: 'Heart-shaped photographs and a delicate keepsake border.' },
    { id: 'clock-four-round', label: 'Four-Photo Clock', description: 'Four circular photos with original vector clock markers.' },
    { id: 'photo-grid', label: 'Photo Grid', description: 'An adaptive edge-to-edge collage for one to twelve photos.' }
  ];
  // Versioned families are immutable production definitions. Assign them through
  // a reusable template set; they never join the legacy generic layout picker.
  var PREDEFINED = {
    'clock-four-seasons-v1': {photoCount:4,overlayPolicy:'none',squareOnly:true,background:'#ffffff',ink:'#252525',defaultFont:'great-vibes',textFields:[{id:'top',label:'Upper message',maxLength:60,required:false,default:'You are my most'},{id:'bottom',label:'Lower message',maxLength:60,required:false,default:'romantic four seasons'}]},
    'clock-twelve-memories-v1': {photoCount:12,overlayPolicy:'none',squareOnly:true,background:'#202124',ink:'#ffffff',defaultFont:'serif',textFields:[{id:'top',label:'First message',maxLength:60,required:false,default:'Our favorite moments'},{id:'bottom',label:'Second message',maxLength:60,required:false,default:'Together, always'}]},
    'three-photo-story-v1': {photoCount:3,overlayPolicy:'none',background:'#517899',ink:'#ffffff',defaultFont:'great-vibes',textFields:[{id:'top',label:'Top message',maxLength:80,required:false,default:'The moments we treasure'},{id:'bottom',label:'Bottom message',maxLength:80,required:false,default:'A lifetime of love'}]},
    'ten-photo-love-v1': {photoCount:10,overlayPolicy:'none',background:'#a62335',ink:'#ffffff',defaultFont:'serif',textFields:[{id:'top',label:'Message above heart',maxLength:40,required:false,default:'I'},{id:'bottom',label:'Message below heart',maxLength:40,required:false,default:'YOU'}]},
    'floral-message-v1': {photoCount:0,overlayPolicy:'none',background:'#fffdf7',ink:'#702a35',defaultFont:'serif',textFields:[{id:'quote',label:'Your message',maxLength:120,required:true,default:'May every step\nbring you closer to\nthe life you love.'},{id:'names',label:'Names or signature',maxLength:70,required:false,default:'With all our love'},{id:'date',label:'Date or occasion',maxLength:50,required:false,default:'A day to remember'}]},
    'two-photo-story-v1': {photoCount:2,overlayPolicy:'none',background:'#466b91',ink:'#ffffff',defaultFont:'great-vibes',textFields:[{id:'top',label:'Upper photo message',maxLength:80,required:false,default:'You make every day brighter'},{id:'bottom',label:'Lower photo message',maxLength:80,required:false,default:'Forever, side by side'}]}
  };
  [
    ['clock-four-seasons-v1','Four Seasons Clock','Four circular photographs with a built-in vector dial.'],
    ['clock-twelve-memories-v1','Twelve Memories Clock','Twelve photographs surrounding a built-in vector dial.'],
    ['three-photo-story-v1','Three-Photo Story','One tall photograph and two stacked photographs, framed by your words.'],
    ['ten-photo-love-v1','Ten Photos, One Love','Ten photographs surrounding a heart and your message.'],
    ['floral-message-v1','Floral Message','Original floral line art, a personal quotation, names and a date.'],
    ['two-photo-story-v1','Two-Photo Story','Two stacked photographs with vertical message ribbons.']
  ].forEach(function(f){FAMILIES.push({id:f[0],label:f[1],description:f[2],photoCount:PREDEFINED[f[0]].photoCount,overlayPolicy:'none',squareOnly:PREDEFINED[f[0]].squareOnly===true});});
  function templateDefinition(templateId) { if(!has(PREDEFINED,templateId))return null;var d=clone(PREDEFINED[templateId]);d.textFields.forEach(function(f){f.rotation=templateId==='two-photo-story-v1'?(f.id==='top'?-90:90):0;});return d; }
  function compatibleTemplate(templateId,count,width,height) {
    if(has(PREDEFINED,templateId))return PREDEFINED[templateId].photoCount===count&&(!PREDEFINED[templateId].squareOnly||width===height);
    if(templateId==='clock-four-round')return count===4&&width===height;
    return count>=1&&count<=(templateId==='photo-grid'?12:4);
  }
  var FONT_IDS = ['sans', 'serif', 'great-vibes', 'pacifico', 'caveat', 'bebas-neue', 'bangers', 'elegance-serif'];
  var MAX_EDGE = 20000;
  var MAX_PIXELS = 250000000;
  var ID_RE = /^[1-9][0-9]{0,19}$/;
  var COLOR_RE = /^#[0-9a-fA-F]{6}$/;
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  function fail(message) { throw new Error('Template configuration: ' + message); }
  function record(v, label) {
    if (!v || typeof v !== 'object' || Array.isArray(v)) fail(label + ' must be an object.');
    return v;
  }
  function int(v, min, max, label) {
    if (typeof v !== 'number' || !isFinite(v) || Math.floor(v) !== v || v < min || v > max) fail(label + ' is outside the supported range.');
    return v;
  }
  function number(v, min, max, label) {
    if (typeof v !== 'number' || !isFinite(v) || v < min || v > max) fail(label + ' is outside the supported range.');
    return v;
  }
  function id(v, label) {
    if (typeof v === 'number' && (!Number.isSafeInteger(v) || v < 1)) fail(label + ' must be a lossless Shopify ID.');
    if (typeof v !== 'string' && typeof v !== 'number') fail(label + ' must be a Shopify ID.');
    var result = String(v);
    if (!ID_RE.test(result)) fail(label + ' must be a Shopify ID.');
    return result;
  }
  function string(v, max, label, empty) {
    if (typeof v !== 'string' || (!empty && !v.trim()) || Array.from(v).length > max || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(v)) fail(label + ' is not valid text.');
    return v;
  }
  function color(v, label) {
    if (typeof v !== 'string' || !COLOR_RE.test(v)) fail(label + ' must be a six-digit hex color.');
    return v.toLowerCase();
  }
  function familyId(v) {
    if (!FAMILIES.some(function (f) { return f.id === v; })) fail('The template family is not supported by this release.');
    return v;
  }
  function clone(v) { return JSON.parse(JSON.stringify(v)); }
  function cleanNumber(v) { return Math.round(v * 100000000) / 100000000; }

  function profileKey(key, productId) {
    if (typeof key !== 'string') fail('Profile key must be a relative S3 key.');
    var match = /^backimg\/gio-templates\/profiles\/([1-9][0-9]{0,19})\/([1-9][0-9]{0,9})\.json$/.exec(key);
    if (!match) fail('Profile key must use the approved product/version directory.');
    if (productId != null && match[1] !== id(productId, 'Product ID')) fail('Profile key belongs to a different product.');
    int(Number(match[2]), 1, 2147483647, 'Profile version');
    return key;
  }

  function validateProfile(profile, expectedProductId) {
    record(profile, 'Profile');
    if (profile.schema !== 'gio-template-profile-v1') fail('Unsupported profile schema.');
    var productId = id(profile.productId, 'Product ID');
    if (expectedProductId != null && productId !== id(expectedProductId, 'Product ID')) fail('Profile belongs to a different product.');
    var version = int(profile.version, 1, 2147483647, 'Profile version');
    if (profile.templateVersion !== 1) fail('This template revision requires a different editor release.');
    if (!Array.isArray(profile.templateIds) || !profile.templateIds.length || profile.templateIds.length > FAMILIES.length) fail('Choose at least one supported template family.');
    var templateIds = profile.templateIds.map(familyId);
    if (new Set(templateIds).size !== templateIds.length) fail('Template families must be unique.');
    var defaultTemplateId = familyId(profile.defaultTemplateId);
    if (templateIds.indexOf(defaultTemplateId) < 0) fail('The default template must be in templateIds.');
    if (typeof profile.allowBackground !== 'boolean') fail('allowBackground must be true or false.');
    if (FONT_IDS.indexOf(profile.defaultFont) < 0) fail('The default font is unavailable.');

    var assignedOnly=templateIds.every(function(t){return has(PREDEFINED,t);});
    if (!Array.isArray(profile.textFields) || profile.textFields.length>8 || !profile.textFields.length) fail('Define between one and eight text fields.');
    var fieldIds=profile.textFields.map(function(f){return f&&f.id;});
    if(new Set(fieldIds).size!==fieldIds.length)fail('Text field IDs must be unique.');
    if(!assignedOnly&&(fieldIds.length!==2||fieldIds.indexOf('top')<0||fieldIds.indexOf('bottom')<0))fail('Define the top and bottom text fields.');
    if(assignedOnly)templateIds.forEach(function(t){var expected=PREDEFINED[t].textFields.map(function(f){return f.id;});if(expected.length!==fieldIds.length||expected.some(function(k){return fieldIds.indexOf(k)<0;}))fail('Text fields must match the assigned template.');});
    var textFields = (assignedOnly?profile.textFields:['top','bottom'].map(function(k){return profile.textFields.filter(function(f){return f.id===k;})[0];})).map(function(input) {
      var field=record(input,'Text field'),fieldId=field.id;
      if(typeof fieldId!=='string'||!/^[a-z][a-z0-9-]{0,31}$/.test(fieldId))fail('Invalid text field ID.');
      var maximum = int(field.maxLength, 1, 120, 'Text field length');
      if (typeof field.required !== 'boolean') fail('Text field required must be true or false.');
      return { id: fieldId, label: string(field.label, 64, 'Text label'), maxLength: maximum,
        required: field.required, default: string(field.default == null ? '' : field.default, maximum, 'Default message', true) };
    });

    var palettes = profile.palettes == null ? [] : profile.palettes;
    if (!Array.isArray(palettes) || palettes.length > 32) fail('Use at most thirty-two palettes.');
    palettes = palettes.map(function (palette) {
      record(palette, 'Palette');
      return { label: string(palette.label, 48, 'Palette label'), background: color(palette.background, 'Palette background'), ink: color(palette.ink, 'Palette ink') };
    });

    record(profile.variants, 'Variants');
    var variantIds = Object.keys(profile.variants);
    if (!variantIds.length || variantIds.length > 4096) fail('Define between one and 4096 variants.');
    var variants = Object.create(null);
    variantIds.forEach(function (variantId) {
      id(variantId, 'Variant ID');
      var variant = record(profile.variants[variantId], 'Variant ' + variantId);
      ['price', 'compareAtPrice', 'compare_at_price', 'available', 'inventory', 'inventory_quantity'].forEach(function (key) {
        if (has(variant, key)) fail('Prices and inventory must come from Shopify, not the template profile.');
      });
      var width = int(variant.width, 1, MAX_EDGE, 'Output width');
      var height = int(variant.height, 1, MAX_EDGE, 'Output height');
      if (width * height > MAX_PIXELS) fail('Output is larger than 250 million pixels.');
      if (width / height < 0.25 || width / height > 4) fail('The supported product aspect range is 1:4 through 4:1.');
      var physicalWidth = number(variant.physicalWidthInches, 0.01, 2000, 'Physical width');
      var physicalHeight = number(variant.physicalHeightInches, 0.01, 2000, 'Physical height');
      if (Math.abs(width * physicalHeight - height * physicalWidth) > physicalWidth + physicalHeight + 0.00001) fail('Production pixels must have the same aspect ratio as the physical product.');
      variants[variantId] = { photoCount: int(variant.photoCount, 0, 12, 'Photo count'), width: width, height: height,
        background: color(variant.background, 'Background'), ink: color(variant.ink, 'Ink'),
        physicalWidthInches: physicalWidth, physicalHeightInches: physicalHeight };
      if(templateIds.indexOf('clock-four-round')>=0&&(variants[variantId].photoCount!==4||width!==height))fail('The four-photo clock template requires four photos and a square output.');
      if(templateIds.some(function(t){return !compatibleTemplate(t,variants[variantId].photoCount,width,height);}))fail('The template does not support this photo count or output aspect ratio.');
    });
    return { schema: 'gio-template-profile-v1', productId: productId, version: version, templateVersion: 1,
      title: string(profile.title == null ? 'Personalize your keepsake' : profile.title, 120, 'Title'),
      templateIds: templateIds, defaultTemplateId: defaultTemplateId, variants: variants,
      textFields: textFields, allowBackground: profile.allowBackground, palettes: palettes, defaultFont: profile.defaultFont };
  }

  function resolve(profile, variantId, requestedTemplateId) {
    var p = validateProfile(profile);
    var vId = id(variantId, 'Variant ID');
    if (!has(p.variants, vId)) fail('This variant does not have an approved template configuration.');
    var templateId = requestedTemplateId == null ? p.defaultTemplateId : familyId(requestedTemplateId);
    if (p.templateIds.indexOf(templateId) < 0) fail('This template is not enabled for this product.');
    var result = clone(p.variants[vId]);
    result.profileVersion = p.version;
    result.productId = p.productId;
    result.variantId = vId;
    result.templateId = templateId;
    result.templateVersion = p.templateVersion;
    result.title = p.title;
    result.templateIds = p.templateIds.slice();
    result.textFields = clone(p.textFields);
    result.allowBackground = p.allowBackground;
    result.palettes = clone(p.palettes);
    result.defaultFont = p.defaultFont;
    return result;
  }

  function normalized(rect, W, H) {
    return { x: cleanNumber(rect.x / W), y: cleanNumber(rect.y / H), width: cleanNumber(rect.width / W), height: cleanNumber(rect.height / H) };
  }
  function cellsForCount(count, area, gap) {
    var x = area.x, y = area.y, w = area.width, h = area.height;
    var wide = w >= h * 1.12;
    if (count === 1) return [area];
    if (count === 2) return wide ? [
      { x:x, y:y, width:(w-gap)/2, height:h }, { x:x+(w+gap)/2, y:y, width:(w-gap)/2, height:h }
    ] : [
      { x:x, y:y, width:w, height:(h-gap)/2 }, { x:x, y:y+(h+gap)/2, width:w, height:(h-gap)/2 }
    ];
    if (count === 3) return wide ? [
      { x:x, y:y, width:(w-gap)*0.53, height:h },
      { x:x+(w-gap)*0.53+gap, y:y, width:(w-gap)*0.47, height:(h-gap)/2 },
      { x:x+(w-gap)*0.53+gap, y:y+(h+gap)/2, width:(w-gap)*0.47, height:(h-gap)/2 }
    ] : [
      { x:x, y:y, width:w, height:(h-gap)*0.53 },
      { x:x, y:y+(h-gap)*0.53+gap, width:(w-gap)/2, height:(h-gap)*0.47 },
      { x:x+(w+gap)/2, y:y+(h-gap)*0.53+gap, width:(w-gap)/2, height:(h-gap)*0.47 }
    ];
    return [
      { x:x, y:y, width:(w-gap)/2, height:(h-gap)/2 },
      { x:x+(w+gap)/2, y:y, width:(w-gap)/2, height:(h-gap)/2 },
      { x:x, y:y+(h+gap)/2, width:(w-gap)/2, height:(h-gap)/2 },
      { x:x+(w+gap)/2, y:y+(h+gap)/2, width:(w-gap)/2, height:(h-gap)/2 }
    ];
  }

  function pathDecoration(d, fill, stroke, strokeWidth, opacity) {
    return { type:'path', d:d, fill:fill || 'none', stroke:stroke || 'none', strokeWidth:strokeWidth || 0, opacity:opacity == null ? 1 : opacity };
  }
  function frame(x,y,width,height,strokeWidth,opacity) {
    return { type:'rect', x:x, y:y, width:width, height:height, rx:0, fill:'none', stroke:'ink', strokeWidth:strokeWidth, opacity:opacity == null ? 1 : opacity };
  }
  function line(x1,y1,x2,y2,strokeWidth,opacity) {
    return pathDecoration('M '+x1+' '+y1+' L '+x2+' '+y2, 'none', 'ink', strokeWidth, opacity);
  }
  function heartPath(W, H) {
    function p(x,y) { return cleanNumber(x*W)+' '+cleanNumber(y*H); }
    return 'M '+p(.5,.95)+' C '+p(.43,.87)+' '+p(.055,.61)+' '+p(.04,.32)+
      ' C '+p(.026,.09)+' '+p(.32,-.01)+' '+p(.5,.19)+
      ' C '+p(.68,-.01)+' '+p(.974,.09)+' '+p(.96,.32)+
      ' C '+p(.945,.61)+' '+p(.57,.87)+' '+p(.5,.95)+' Z';
  }
  function translatedHeart(x,y,size) {
    // Original compact decoration, coordinates compiled numerically (no transform).
    var commands = [['M',.5,.95],['C',.43,.87,.055,.61,.04,.32],['C',.026,.09,.32,-.01,.5,.19],['C',.68,-.01,.974,.09,.96,.32],['C',.945,.61,.57,.87,.5,.95]];
    return commands.map(function(c){return c[0]+' '+c.slice(1).map(function(n,i){return cleanNumber((i%2 ? y : x)+n*size);}).join(' ');}).join(' ')+' Z';
  }
  function botanicalBranch(x,y,size,mirrorX,mirrorY) {
    function pt(a,b) { return cleanNumber(x+a*size*mirrorX)+' '+cleanNumber(y+b*size*mirrorY); }
    var result = [pathDecoration('M '+pt(0,.78)+' Q '+pt(.23,.25)+' '+pt(.82,0), 'none','ink',size*.014,.7)];
    [[.14,.49,.015,.25,.25,.28],[.3,.29,.18,.08,.42,.12],[.5,.13,.5,-.1,.65,.065],
      [.18,.47,.43,.53,.34,.32],[.37,.25,.63,.34,.52,.14],[.63,.055,.89,.15,.78,0]].forEach(function(a){
      result.push(pathDecoration('M '+pt(a[0],a[1])+' Q '+pt(a[2],a[3])+' '+pt(a[4],a[5])+' Q '+pt((a[0]+a[4])*.5+.025,(a[1]+a[5])*.5+.025)+' '+pt(a[0],a[1])+' Z','ink','none',0,.7));
    });
    return result;
  }

  function clockNumberPath(value,cx,cy,height) {
    // Original geometric numerals composed from seven simple line segments.
    var digitSegments=['abcedf','bc','abged','abgcd','fgbc','afgcd','afgecd','abc','abcdefg','abfgcd'];
    var segments={a:[0,0,1,0],b:[1,0,1,1],c:[1,1,1,2],d:[1,2,0,2],e:[0,2,0,1],f:[0,1,0,0],g:[0,1,1,1]};
    var digits=String(value).split(''), width=height*.5, gap=height*.22;
    var left=cx-(digits.length*width+(digits.length-1)*gap)/2;
    return digits.map(function(d,index){return digitSegments[Number(d)].split('').map(function(segment){
      var p=segments[segment],x=left+index*(width+gap),y=cy-height/2;
      return 'M '+cleanNumber(x+p[0]*width)+' '+cleanNumber(y+p[1]*height/2)+' L '+cleanNumber(x+p[2]*width)+' '+cleanNumber(y+p[3]*height/2);
    }).join(' ');}).join(' ');
  }

  function buildClockTemplate(resolved) {
    if (resolved.photoCount!==4 || resolved.width!==resolved.height) fail('The four-photo clock template requires four photos and a square output.');
    var W=1000,H=1000,side=270;
    var positions=[[500,230,'Top photo'],[770,500,'Right photo'],[500,770,'Bottom photo'],[230,500,'Left photo']];
    var slots=positions.map(function(p,index){return {id:'photo-'+(index+1),label:p[2],mask:'round',radius:0,
      rect:normalized({x:p[0]-side/2,y:p[1]-side/2,width:side,height:side},W,H)};});
    var decorations=[];
    for(var minute=0;minute<60;minute++) {
      var angle=minute*Math.PI/30-Math.PI/2,major=minute%5===0,outer=480,inner=major?463:471;
      decorations.push(line(500+Math.cos(angle)*inner,500+Math.sin(angle)*inner,500+Math.cos(angle)*outer,500+Math.sin(angle)*outer,major?2.5:1.1,major?.95:.55));
    }
    for(var hour=1;hour<=12;hour++) {
      var theta=hour*Math.PI/6-Math.PI/2;
      decorations.push(pathDecoration(clockNumberPath(hour,500+Math.cos(theta)*428,500+Math.sin(theta)*428,32),'none','ink',2.8,.95));
    }
    var textRects=[{x:.375,y:.410,width:.250,height:.042},{x:.375,y:.548,width:.250,height:.042}];
    var textFields=['top','bottom'].map(function(fieldId,index){
      var field=(resolved.textFields||[]).filter(function(f){return f.id===fieldId;})[0];
      if(!field)fail('Missing resolved text field.');
      var out=clone(field);out.rect=textRects[index];out.align='center';out.font=resolved.defaultFont;return out;
    });
    return {templateId:'clock-four-round',templateVersion:1,photoCount:4,viewBox:[0,0,1000,1000],
      slots:slots,textFields:textFields,decorations:decorations,
      safeZones:[{id:'clock-center',label:'Clock movement clearance',rect:{x:.45,y:.46,width:.10,height:.08},print:false}],
      geometryKey:'t1:clock-four-round:4:1'};
  }

  function buildGridTemplate(resolved) {
    var count=resolved.photoCount, W=1000, H=W/(resolved.layoutAspect==null?resolved.width/resolved.height:number(resolved.layoutAspect,.25,4,'Layout aspect')), S=Math.min(W,H);
    // Choose rows to keep the average image cell near-square; each row fills its width.
    // No geometry in the four original families is changed by this separate compiler.
    var rows=1, best=Infinity;
    for(var r=1;r<=count;r++) {
      var avg=count/r, ratio=(W/avg)/(H/r), score=Math.abs(Math.log(ratio))+.08*((count%r)?1:0);
      if(score<best){best=score;rows=r;}
    }
    var slots=[], remaining=count, index=0, gap=count===1?0:S*.012;
    for(var row=0;row<rows;row++) {
      var columns=Math.ceil(remaining/(rows-row));remaining-=columns;
      var h=(H-gap*(rows-1))/rows,w=(W-gap*(columns-1))/columns;
      for(var col=0;col<columns;col++) slots.push({id:'photo-'+(++index),label:'Photo '+index,
        rect:normalized({x:col*(w+gap),y:row*(h+gap),width:w,height:h},W,H),mask:'rect',radius:0});
    }
    var textFields=['top','bottom'].map(function(fieldId,index){
      var input=(resolved.textFields||[]).filter(function(f){return f.id===fieldId;})[0];
      if(!input)fail('Missing resolved text field.');var out=clone(input);
      out.rect=normalized({x:W*.1,y:index===0?S*.08:H-S*.18,width:W*.8,height:S*.1},W,H);
      out.align='center';out.font=resolved.defaultFont;return out;
    });
    return {templateId:'photo-grid',templateVersion:1,photoCount:count,viewBox:[0,0,W,H],slots:slots,
      textFields:textFields,decorations:[],geometryKey:'t1:photo-grid:'+count+':'+cleanNumber(W/H)};
  }

  // Curved, original vector numerals. These paths require no installed fonts.
  function softNumberPath(value,cx,cy,height) {
    var glyphs=['M .5 0 C -.17 0 -.17 2 .5 2 C 1.17 2 1.17 0 .5 0 Z','M .12 .35 L .55 0 L .55 2 M .13 2 L .97 2','M 0 .38 C .02 -.16 1 -.16 1 .42 C 1 .82 .05 1.45 0 2 L 1 2','M 0 .22 C .25 -.12 1 -.08 1 .42 C 1 .78 .7 1 .42 1 C .78 1 1 1.16 1 1.55 C 1 2.13 .25 2.14 0 1.77','M .8 2 L .8 0 L 0 1.35 L 1.1 1.35','M 1 0 L .12 0 L .03 .9 C .95 .55 1.28 1.3 .86 1.8 C .58 2.13 .05 2.04 0 1.8','M .92 .1 C -.05 -.32 -.27 2 .5 2 C 1.15 2 1.21 .89 .55 .87 C .22 .86 .02 1.08 .02 1.3','M 0 0 L 1 0 L .2 2','M .5 0 C -.18 0 -.11 .91 .5 1 C 1.15 1.1 1.18 2 .5 2 C -.18 2 -.15 1.1 .5 1 C 1.11 .91 1.18 0 .5 0 Z','M .08 1.9 C 1.05 2.32 1.27 0 .5 0 C -.15 0 -.21 1.11 .45 1.13 C .78 1.14 .98 .92 .98 .7'];
    var digits=String(value).split(''),w=height*.49,gap=height*.19,left=cx-(digits.length*w+(digits.length-1)*gap)/2;
    return digits.map(function(d,index){var pair=0;return glyphs[Number(d)].replace(/[MLCZ]|-?(?:\d*\.)?\d+/g,function(token){if(/^[MLCZ]$/.test(token)){pair=0;return token;}var n=Number(token),isY=(pair++%2)===1;return cleanNumber(isY?cy-height/2+n*height/2:left+index*(w+gap)+n*w);});}).join(' ');
  }
  function floralBloom(cx,cy,size,stroke) {
    var out=[];
    for(var petal=0;petal<7;petal++) {
      var a=petal*Math.PI*2/7,co=Math.cos(a),si=Math.sin(a);
      function p(x,y){return cleanNumber(cx+(x*co-y*si)*size)+' '+cleanNumber(cy+(x*si+y*co)*size);}
      out.push(pathDecoration('M '+p(.06,0)+' C '+p(.21,-.3)+' '+p(.58,-.24)+' '+p(.48,.01)+' C '+p(.39,.28)+' '+p(.16,.2)+' '+p(.06,0),'none',stroke,size*.012,1));
      out.push(pathDecoration('M '+p(.1,.005)+' Q '+p(.26,-.055)+' '+p(.42,.015),'none',stroke,size*.006,.8));
    }
    out.push(pathDecoration('M '+(cx-size*.08)+' '+cy+' C '+(cx-size*.08)+' '+(cy-size*.11)+' '+(cx+size*.1)+' '+(cy-size*.1)+' '+(cx+size*.08)+' '+cy+' C '+(cx+size*.08)+' '+(cy+size*.11)+' '+(cx-size*.08)+' '+(cy+size*.11)+' '+(cx-size*.08)+' '+cy+' Z','none',stroke,size*.012,1));
    return out;
  }
  function buildPredefinedTemplate(resolved) {
    var def=PREDEFINED[resolved.templateId],aspect=resolved.layoutAspect==null?resolved.width/resolved.height:number(resolved.layoutAspect,.25,4,'Layout aspect');
    if(!compatibleTemplate(resolved.templateId,resolved.photoCount,resolved.width,resolved.height))fail('Assigned template count or size does not match.');
    if(def.squareOnly&&Math.abs(aspect-1)>1e-7)fail('Clock template requires a square print surface.');
    var W=1000,H=W/aspect,S=Math.min(W,H),slots=[],decorations=[],fieldRects={},rotations={},safeZones=[];
    function slot(x,y,w,h,mask,label){slots.push({id:'photo-'+(slots.length+1),label:label||'Photo '+(slots.length+1),rect:normalized({x:x,y:y,width:w,height:h},W,H),mask:mask||'rect',radius:0});}
    function tf(id,x,y,w,h,rotation){fieldRects[id]=normalized({x:x,y:y,width:w,height:h},W,H);rotations[id]=rotation||0;}
    if(resolved.templateId==='clock-four-seasons-v1') {
      var side=258;[[500,162,'Top photo'],[838,500,'Right photo'],[500,838,'Bottom photo'],[162,500,'Left photo']].forEach(function(p){slot(p[0]-side/2,p[1]-side/2,side,side,'round',p[2]);});
      [1,2,4,5,7,8,10,11].forEach(function(n){var a=n*Math.PI/6-Math.PI/2;decorations.push(pathDecoration(softNumberPath(n,500+Math.cos(a)*417,500+Math.sin(a)*417,57),'none','ink',3.4,1));});
      tf('top',300,315,400,68);tf('bottom',270,621,460,68);
      safeZones.push({id:'clock-center',label:'Clock movement clearance',rect:{x:.455,y:.44,width:.09,height:.12},print:false});
    } else if(resolved.templateId==='clock-twelve-memories-v1') {
      var pad=22,gap=14,cell=(W-2*pad-3*gap)/4;
      for(var c=0;c<4;c++)slot(pad+c*(cell+gap),pad,cell,cell);
      for(var r=1;r<3;r++)slot(pad+3*(cell+gap),pad+r*(cell+gap),cell,cell);
      for(var b=3;b>=0;b--)slot(pad+b*(cell+gap),pad+3*(cell+gap),cell,cell);
      for(var l=2;l>=1;l--)slot(pad,pad+l*(cell+gap),cell,cell);
      slots.forEach(function(s){var a=s.rect;decorations.push({type:'rect',x:a.x*W-3,y:a.y*H-3,width:a.width*W+6,height:a.height*H+6,rx:0,fill:'none',stroke:'#ffffff',strokeWidth:4,opacity:1});});
      for(var n=1;n<=12;n++){var angle=n*Math.PI/6-Math.PI/2;decorations.push(pathDecoration(softNumberPath(n,500+Math.cos(angle)*194,485+Math.sin(angle)*194,27),'none','ink',2.3,1));}
      tf('top',365,536,270,33);tf('bottom',365,577,270,29);
      safeZones.push({id:'clock-center',label:'Clock movement clearance',rect:{x:.46,y:.44,width:.08,height:.08},print:false});
    } else if(resolved.templateId==='three-photo-story-v1') {
      var pad=S*.052,gap=S*.027,top=H*.14,bottom=H*.86,h=bottom-top,left=(W-2*pad-gap)*.53,right=W-2*pad-gap-left;
      slot(pad,top,left,h);slot(pad+left+gap,top,right,(h-gap)/2);slot(pad+left+gap,top+(h+gap)/2,right,(h-gap)/2);
      tf('top',W*.095,H*.033,W*.81,H*.076);tf('bottom',W*.095,H*.889,W*.81,H*.076);
    } else if(resolved.templateId==='ten-photo-love-v1') {
      var pad=S*.035,gap=S*.016,iw=W-2*pad,ih=H-2*pad,sideW=iw*.255,bandH=ih*.235,middleW=iw-2*sideW-2*gap,middleH=ih-2*bandH-2*gap;
      slot(pad,pad,sideW,bandH);slot(pad+sideW+gap,pad,middleW,bandH);slot(W-pad-sideW,pad,sideW,bandH);
      slot(W-pad-sideW,pad+bandH+gap,sideW,(middleH-gap)/2);slot(W-pad-sideW,pad+bandH+gap+(middleH+gap)/2,sideW,(middleH-gap)/2);
      slot(W-pad-sideW,H-pad-bandH,sideW,bandH);slot(pad+sideW+gap,H-pad-bandH,middleW,bandH);slot(pad,H-pad-bandH,sideW,bandH);
      slot(pad,pad+bandH+gap+(middleH+gap)/2,sideW,(middleH-gap)/2);slot(pad,pad+bandH+gap,sideW,(middleH-gap)/2);
      var centerX=pad+sideW+gap,centerY=pad+bandH+gap,heartSize=Math.min(middleW*.7,middleH*.42);
      decorations.push(pathDecoration(translatedHeart(W/2-heartSize/2,H/2-heartSize/2,heartSize),'ink','none',0,1));
      tf('top',centerX+middleW*.04,centerY+middleH*.035,middleW*.92,middleH*.18);
      tf('bottom',centerX+middleW*.04,centerY+middleH*.77,middleW*.92,middleH*.18);
    } else if(resolved.templateId==='floral-message-v1') {
      var red='#96384d',gold='#bd9657',flowers=[[.05,.055,.34,red],[.16,.015,.25,gold],[.04,.31,.27,red],[.94,.075,.28,red],[.97,.33,.25,gold],[.055,.92,.3,red],[.24,.99,.29,gold],[.92,.93,.36,red],[.99,.7,.23,gold]];
      flowers.forEach(function(f){decorations=decorations.concat(floralBloom(W*f[0],H*f[1],S*f[2],f[3]));});
      [[.1,.1,1,1],[.89,.16,-1,1],[.13,.83,1,-1],[.88,.88,-1,-1]].forEach(function(p){var branch=botanicalBranch(W*p[0],H*p[1],S*.15,p[2],p[3]);branch.forEach(function(d){if(d.fill==='ink')d.fill=gold;if(d.stroke==='ink')d.stroke=gold;d.opacity=.8;});decorations=decorations.concat(branch);});
      [[.22,.1],[.7,.1],[.89,.47],[.07,.59],[.28,.87],[.68,.94],[.92,.63],[.43,.075],[.54,.94],[.075,.43],[.81,.22]].forEach(function(p){var q=S*.0038;decorations.push({type:'rect',x:W*p[0],y:H*p[1],width:q,height:q,rx:0,fill:gold,stroke:'none',strokeWidth:0,opacity:.8});});
      tf('quote',W*.18,H*.27,W*.64,H*.3);tf('names',W*.22,H*.63,W*.56,H*.075);tf('date',W*.25,H*.74,W*.5,H*.055);
    } else if(resolved.templateId==='two-photo-story-v1') {
      var pad=S*.052,gap=S*.035,stripe=S*.115,innerW=W-2*pad,halfH=(H-2*pad-gap)/2;
      slot(pad,pad,innerW-stripe-gap,halfH);slot(pad+stripe+gap,pad+halfH+gap,innerW-stripe-gap,halfH);
      tf('top',W-pad-stripe,pad+halfH*.035,stripe,halfH*.93,-90);
      tf('bottom',pad,pad+halfH+gap+halfH*.035,stripe,halfH*.93,90);
    }
    var fields=def.textFields.map(function(defField){var input=(resolved.textFields||[]).filter(function(f){return f.id===defField.id;})[0];if(!input)fail('Missing assigned template text field.');var out=clone(input);out.rect=fieldRects[out.id];out.rotation=rotations[out.id];out.align='center';out.font=resolved.defaultFont;return out;});
    return{templateId:resolved.templateId,templateVersion:1,photoCount:resolved.photoCount,viewBox:[0,0,W,H],slots:slots,textFields:fields,decorations:decorations,safeZones:safeZones,overlayPolicy:'none',geometryKey:'t1:'+resolved.templateId+':'+resolved.photoCount+':'+cleanNumber(aspect)};
  }

  function buildTemplate(resolved) {
    record(resolved, 'Resolved template');
    var templateId = familyId(resolved.templateId);
    if (resolved.templateVersion !== 1) fail('Unsupported geometry revision.');
    var count = int(resolved.photoCount,has(PREDEFINED,templateId)?0:1,has(PREDEFINED,templateId)||templateId==='photo-grid'?12:4,'Photo count');
    var outputW = int(resolved.width,1,MAX_EDGE,'Output width');
    var outputH = int(resolved.height,1,MAX_EDGE,'Output height');
    if (outputW*outputH > MAX_PIXELS) fail('Output is larger than 250 million pixels.');
    if(has(PREDEFINED,templateId))return buildPredefinedTemplate(resolved);
    if (templateId==='clock-four-round') return buildClockTemplate(resolved);
    if (templateId==='photo-grid') return buildGridTemplate(resolved);
    var aspect = resolved.layoutAspect==null?outputW/outputH:number(resolved.layoutAspect,.25,4,'Layout aspect');
    if (aspect<.25 || aspect>4) fail('Unsupported aspect ratio.');
    var W = 1000, H = W/aspect, S = Math.min(W,H), pad = S*.065;
    var top = { x:W*.13, y:pad+S*.018, width:W*.74, height:S*.09 };
    var bottom = { x:W*.13, y:H-pad-S*.108, width:W*.74, height:S*.09 };
    if (templateId==='botanical-keepsake') {
      top.x=bottom.x=Math.max(W*.13,pad+S*.17);
      top.width=bottom.width=W-2*top.x;
    }
    var extra = templateId === 'botanical-keepsake' ? .055*S : .025*S;
    var area = { x:pad+extra, y:top.y+top.height+S*.055,
      width:W-2*(pad+extra), height:bottom.y-S*.055-(top.y+top.height+S*.055) };
    var gap = S*(templateId === 'family-moments' ? .022 : .035);
    var slots = cellsForCount(count,area,gap).map(function(cell,index) {
      var mask = templateId === 'botanical-keepsake' ? 'round' : templateId === 'love-memories' ? 'heart' : 'rect';
      if (mask !== 'rect') {
        var side = Math.min(cell.width,cell.height);
        cell = { x:cell.x+(cell.width-side)/2, y:cell.y+(cell.height-side)/2, width:side, height:side };
      }
      return { id:'photo-'+(index+1), label:'Photo '+(index+1), rect:normalized(cell,W,H), mask:mask, radius:mask==='rect' ? .018 : 0 };
    });
    var decorations = [];
    if (templateId === 'family-moments') {
      decorations.push(frame(pad*.53,pad*.53,W-pad*1.06,H-pad*1.06,S*.0025,.7));
      decorations.push(frame(pad*.72,pad*.72,W-pad*1.44,H-pad*1.44,S*.0009,.45));
      decorations.push(line(W*.37,top.y+top.height+S*.018,W*.63,top.y+top.height+S*.018,S*.0015,.6));
      decorations.push(line(W*.37,bottom.y-S*.018,W*.63,bottom.y-S*.018,S*.0015,.6));
    } else if (templateId === 'botanical-keepsake') {
      decorations.push(frame(pad*.64,pad*.64,W-pad*1.28,H-pad*1.28,S*.0013,.4));
      decorations = decorations.concat(botanicalBranch(pad*.7,pad*.75,S*.17,1,1));
      decorations = decorations.concat(botanicalBranch(W-pad*.7,pad*.75,S*.17,-1,1));
      decorations = decorations.concat(botanicalBranch(pad*.7,H-pad*.75,S*.17,1,-1));
      decorations = decorations.concat(botanicalBranch(W-pad*.7,H-pad*.75,S*.17,-1,-1));
    } else {
      decorations.push(frame(pad*.58,pad*.58,W-pad*1.16,H-pad*1.16,S*.0018,.6));
      var heartSize=S*.028;
      decorations.push(pathDecoration(translatedHeart(W/2-heartSize/2,top.y+top.height+S*.011,heartSize),'ink','none',0,.8));
      decorations.push(line(W*.32,top.y+top.height+S*.025,W/2-heartSize,top.y+top.height+S*.025,S*.0012,.6));
      decorations.push(line(W/2+heartSize,top.y+top.height+S*.025,W*.68,top.y+top.height+S*.025,S*.0012,.6));
      decorations.push(line(W*.38,bottom.y-S*.021,W*.62,bottom.y-S*.021,S*.0012,.6));
    }
    var inputFields = resolved.textFields || [];
    var textFields = ['top','bottom'].map(function(fieldId,index) {
      var input = inputFields.filter(function(field){return field.id===fieldId;})[0];
      if (!input) fail('Missing resolved text field.');
      var out = clone(input);
      out.rect = normalized(index===0 ? top : bottom,W,H);
      out.align = 'center';
      out.font = resolved.defaultFont;
      return out;
    });
    return { templateId:templateId, templateVersion:1, photoCount:count,
      viewBox:[0,0,W,H], slots:slots, textFields:textFields, decorations:decorations,
      geometryKey:'t1:'+templateId+':'+count+':'+cleanNumber(aspect) };
  }

  function maskPath(slot, localWidth, localHeight) {
    record(slot,'Photo slot');
    var W = number(localWidth,.00001,MAX_EDGE,'Mask width');
    var H = number(localHeight,.00001,MAX_EDGE,'Mask height');
    if (slot.mask === 'polygon') {
      var points=slot.points;
      if(!Array.isArray(points)||points.length<3||points.length>256)fail('Polygon mask needs 3 to 256 points.');
      return points.map(function(p,i){if(!Array.isArray(p)||p.length!==2)fail('Polygon points must be [x,y] pairs.');return(i?' L ':'M ')+(number(p[0],0,1,'Polygon x')*W)+' '+(number(p[1],0,1,'Polygon y')*H);}).join('')+' Z';
    }
    if (slot.mask === 'heart') return heartPath(W,H);
    if (slot.mask === 'round') {
      var k = .5522847498307936, cx=W/2, cy=H/2;
      return 'M '+W+' '+cy+' C '+W+' '+(cy+k*cy)+' '+(cx+k*cx)+' '+H+' '+cx+' '+H+
        ' C '+(cx-k*cx)+' '+H+' 0 '+(cy+k*cy)+' 0 '+cy+
        ' C 0 '+(cy-k*cy)+' '+(cx-k*cx)+' 0 '+cx+' 0'+
        ' C '+(cx+k*cx)+' 0 '+W+' '+(cy-k*cy)+' '+W+' '+cy+' Z';
    }
    if (slot.mask !== 'rect') fail('Unsupported photo mask.');
    var radius = slot.radius == null ? 0 : number(slot.radius,0,.5,'Corner radius');
    var r = radius*Math.min(W,H);
    return 'M '+r+' 0 H '+(W-r)+' Q '+W+' 0 '+W+' '+r+' V '+(H-r)+' Q '+W+' '+H+' '+(W-r)+' '+H+
      ' H '+r+' Q 0 '+H+' 0 '+(H-r)+' V '+r+' Q 0 0 '+r+' 0 Z';
  }
  // A bounded, single simple polygon is the production outline contract.
  // Only absolute M/L/Z commands are accepted; curves, subpaths and markup are
  // deliberately excluded so Canvas, SVG and production agree on its boundary.
  function printPathPoints(template) {
    record(template,'Print template');
    var box=template.viewBox, path=template.printPath;
    if(!Array.isArray(box)||box.length!==4||box[0]!==0||box[1]!==0)fail('Print path requires a zero-origin viewBox.');
    var W=number(box[2],1,MAX_EDGE,'Print viewBox width'),H=number(box[3],1,MAX_EDGE,'Print viewBox height');
    if(typeof path!=='string'||!path.trim()||path.length>20000)fail('Print path is empty or too large.');
    var pattern=/[MLZ]|[+-]?(?:\d*\.\d+|\d+\.?\d*)(?:[eE][+-]?\d+)?/g,tokens=[],match,last=0;
    while((match=pattern.exec(path))){if(!/^[\s,]*$/.test(path.slice(last,match.index)))fail('Print path supports only absolute M, L and Z commands.');tokens.push(match[0]);last=pattern.lastIndex;}
    if(!/^[\s,]*$/.test(path.slice(last))||tokens[0]!=='M'||tokens[tokens.length-1]!=='Z'||tokens.length>1026)fail('Print path must be one closed polygon.');
    var points=[],index=0;
    while(index<tokens.length-1){
      var command=tokens[index];
      if(command==='M'||command==='L'){if(command==='M'&&points.length)fail('Print path must contain only one outline.');index++;}
      else if(!points.length)fail('Print path must begin with M.');
      if(index+1>=tokens.length-1||/^[MLZ]$/.test(tokens[index])||/^[MLZ]$/.test(tokens[index+1]))fail('Print path needs coordinate pairs.');
      points.push([number(Number(tokens[index++]),0,W,'Print path x')/W,number(Number(tokens[index++]),0,H,'Print path y')/H]);
    }
    // An explicit final return to the start is equivalent to the closing Z.
    if(points.length>3&&points[0][0]===points[points.length-1][0]&&points[0][1]===points[points.length-1][1])points.pop();
    if(points.length<3||points.length>256)fail('Print path needs 3 to 256 distinct corners.');
    var epsilon=1e-10,n=points.length,area=0;
    function cross(a,b,c){return(b[0]-a[0])*(c[1]-a[1])-(b[1]-a[1])*(c[0]-a[0]);}
    function onSegment(a,b,p){return Math.abs(cross(a,b,p))<=epsilon&&p[0]>=Math.min(a[0],b[0])-epsilon&&p[0]<=Math.max(a[0],b[0])+epsilon&&p[1]>=Math.min(a[1],b[1])-epsilon&&p[1]<=Math.max(a[1],b[1])+epsilon;}
    function intersects(a,b,c,d){var ac=cross(a,b,c),ad=cross(a,b,d),ca=cross(c,d,a),cb=cross(c,d,b);return((ac>epsilon&&ad< -epsilon||ac< -epsilon&&ad>epsilon)&&(ca>epsilon&&cb< -epsilon||ca< -epsilon&&cb>epsilon))||onSegment(a,b,c)||onSegment(a,b,d)||onSegment(c,d,a)||onSegment(c,d,b);}
    for(var i=0;i<n;i++){var next=points[(i+1)%n];area+=points[i][0]*next[1]-next[0]*points[i][1];for(var j=i+1;j<n;j++)if(Math.abs(points[i][0]-points[j][0])<=epsilon&&Math.abs(points[i][1]-points[j][1])<=epsilon)fail('Print path corners must be distinct.');}
    if(Math.abs(area)<=epsilon)fail('Print path must enclose a nonzero area.');
    for(i=0;i<n;i++)for(j=i+1;j<n;j++){if(j===i+1||i===0&&j===n-1)continue;if(intersects(points[i],points[(i+1)%n],points[j],points[(j+1)%n]))fail('Print path edges must not intersect.');}
    return points;
  }
  function slotRotation(slot) {
    record(slot,'Photo slot');
    return slot.rotation===undefined?0:number(slot.rotation,-360,360,'Photo slot rotation');
  }
  // Inputs/outputs are normalized, but rotation happens in physical pixel
  // coordinates. Rotating normalized axes directly distorts non-square slots.
  function slotToCanvas(slot,x,y,width,height) {
    var r=record(slot.rect,'Photo slot rectangle'),W=number(width,.00001,MAX_EDGE,'Canvas width'),H=number(height,.00001,MAX_EDGE,'Canvas height');
    var angle=slotRotation(slot)*Math.PI/180,c=Math.cos(angle),s=Math.sin(angle);
    var dx=(x-.5)*r.width*W,dy=(y-.5)*r.height*H;
    return{x:r.x+r.width/2+(dx*c-dy*s)/W,y:r.y+r.height/2+(dx*s+dy*c)/H};
  }
  function canvasToSlot(slot,x,y,width,height) {
    var r=record(slot.rect,'Photo slot rectangle'),W=number(width,.00001,MAX_EDGE,'Canvas width'),H=number(height,.00001,MAX_EDGE,'Canvas height');
    var angle=slotRotation(slot)*Math.PI/180,c=Math.cos(angle),s=Math.sin(angle);
    var dx=(x-r.x-r.width/2)*W,dy=(y-r.y-r.height/2)*H;
    return{x:.5+(dx*c+dy*s)/(r.width*W),y:.5+(-dx*s+dy*c)/(r.height*H)};
  }
  // Explicit opt-in for single-photo products with transparent outer pixels.
  // Dimensions belong to the render target; file-template geometry itself need
  // not carry output pixels. Legacy rect/round rendering is unchanged.
  function printMaskPath(template, width, height) {
    record(template,'Print template');
    if(template.printShape==='path'){
      var pathW=width==null?(template.width==null?template.viewBox&&template.viewBox[2]:template.width):width;
      var pathH=height==null?(template.height==null?template.viewBox&&template.viewBox[3]:template.height):height;
      number(pathW,.00001,MAX_EDGE,'Print width');number(pathH,.00001,MAX_EDGE,'Print height');
      return printPathPoints(template).map(function(p,i){return(i?' L ':'M ')+(p[0]*pathW)+' '+(p[1]*pathH);}).join('')+' Z';
    }
    if (template.printShape !== 'photo') return null;
    if (!Array.isArray(template.slots) || template.slots.length !== 1) fail('Photo print shape requires exactly one photo slot.');
    var slot=template.slots[0], r=slot && slot.rect;
    if (!r || r.x!==0 || r.y!==0 || r.width!==1 || r.height!==1) fail('Photo print shape requires a full-canvas photo slot.');
    var W=width==null?(template.width==null?template.viewBox&&template.viewBox[2]:template.width):width;
    var H=height==null?(template.height==null?template.viewBox&&template.viewBox[3]:template.height):height;
    return maskPath(slot,W,H);
  }
  function escapeXml(value) { return String(value).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c];}); }
  // Optional background context keeps old callers and legacy output unchanged.
  // New background tokens resolve to the selected palette at render time only.
  function resolvePaint(value,ink,background) { if(value==='ink')return color(ink,'Decoration ink');if(value==='background')return color(background,'Decoration background');return COLOR_RE.test(value)?value:'none'; }
  function decorationsSvg(template, ink, background) {
    var selected = color(ink,'Decoration ink'), selectedBackground = background == null ? template.background : background;
    return template.decorations.map(function(d) {
      var attrs = ' fill="'+resolvePaint(d.fill,selected,selectedBackground)+'" stroke="'+resolvePaint(d.stroke,selected,selectedBackground)+'" stroke-width="'+d.strokeWidth+'" opacity="'+d.opacity+'" stroke-linecap="round" stroke-linejoin="round"';
      if (d.type==='rect') return '<rect x="'+d.x+'" y="'+d.y+'" width="'+d.width+'" height="'+d.height+'" rx="'+d.rx+'"'+attrs+'/>';
      return '<path d="'+escapeXml(d.d)+'"'+attrs+'/>';
    }).join('');
  }
  function drawDecorations(ctx, template, ink, width, height, background) {
    var selected=color(ink,'Decoration ink'),selectedBackground=background==null?template.background:background;
    if (typeof Path2D === 'undefined') throw new Error('This browser needs Canvas Path2D support.');
    ctx.save();
    ctx.scale(width/template.viewBox[2],height/template.viewBox[3]);
    template.decorations.forEach(function(d) {
      var p;
      if (d.type==='path') p = new Path2D(d.d);
      else { p = new Path2D(); p.rect(d.x,d.y,d.width,d.height); }
      ctx.globalAlpha=d.opacity;
      ctx.lineWidth=d.strokeWidth;
      ctx.lineCap='round'; ctx.lineJoin='round';
      var fill=resolvePaint(d.fill,selected,selectedBackground),stroke=resolvePaint(d.stroke,selected,selectedBackground);
      if (fill!=='none') { ctx.fillStyle=fill; ctx.fill(p); }
      if (stroke!=='none') { ctx.strokeStyle=stroke; ctx.stroke(p); }
    });
    ctx.restore();
  }

  return { version:VERSION, templateVersion:1, maxEdge:MAX_EDGE, maxPixels:MAX_PIXELS,
    families:clone(FAMILIES), templateDefinition:templateDefinition, compatibleTemplate:compatibleTemplate, fontIds:FONT_IDS.slice(), validateProfile:validateProfile,
    profileKey:profileKey, resolve:resolve, buildTemplate:buildTemplate,
    maskPath:maskPath, printMaskPath:printMaskPath, printPathPoints:printPathPoints,
    slotRotation:slotRotation, slotToCanvas:slotToCanvas, canvasToSlot:canvasToSlot,
    resolvePaint:resolvePaint, decorationsSvg:decorationsSvg, drawDecorations:drawDecorations };
}));
